import { render, staticRenderFns } from "./lazyblock_newsletter.vue?vue&type=template&id=6b400333&scoped=true"
import script from "./lazyblock_newsletter.vue?vue&type=script&lang=js"
export * from "./lazyblock_newsletter.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_newsletter.vue?vue&type=style&index=0&id=6b400333&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b400333",
  null
  
)

export default component.exports